import { ISeasonResortLiftTickets } from 'api/resort/types';
import CurrencyNotice from 'components/common/CurrencyNotice';
import Grid from 'components/common/Grid/Grid';
import { IGridColumn } from 'components/common/Grid/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IDailyGridDataRow } from './restructureDailyGridData';

import styles from './styles.module.scss';

interface IResortLiftTicketsProps<DataType> {
  columns: IGridColumn[]
  data: DataType
  currency?: string | null
}

const ResortLiftTicketsGrid = (
  { columns, data, currency }
  : IResortLiftTicketsProps<ISeasonResortLiftTickets[] | IDailyGridDataRow[]>,
) => {
  const { t } = useOTSTranslation('common');

  return (
    <>
      {currency && (<CurrencyNotice className={styles.currencyNotice} currency={currency} />)}
      <Grid
        columns={columns}
        data={data}
        total={data.length}
        className={styles.grid}
        noValueSymbol={t('common.dash')}
        noAd
      />
    </>
  );
};

export default ResortLiftTicketsGrid;
